import styled from 'styled-components';
import { BasketPaymentDetailsStyled } from '../BasketPaymentDetailsStyled';
import { rem } from 'polished';

export const BasketPaymentDetailsDS = styled(BasketPaymentDetailsStyled)`
    border-color: ${({ theme }) => theme.colors.secondary};

    .titleWrapper {
        .title {
            font-size: ${({ theme }) => theme.fontSizes.h4};
        }
    }

    .description {
        .link {
            font-size: ${({ theme }) => theme.fontSizes.h5};

            &:hover,
            &:focus-visible {
                color: ${({ theme }) => theme.colors.primary};
            }
        }
    }

    .financeSummary {
        background: ${({ theme }) => theme.colors.white};
        border: 1px solid ${({ theme }) => theme.colors.grey16};
        border-radius: ${rem(8)};

        .monthlyPaymentDetailMobile,
        .monthlyPaymentDesktop {
            .formatMoney {
                font-size: ${({ theme }) => theme.fontSizes.h4};
            }
        }

        .monthlyPaymentDesktop {
            .financeTitle {
                font-size: ${({ theme }) => theme.fontSizes.h4};
            }
        }

        .monthlyPaymentDetailDesktop {
            .link {
                font-size: ${({ theme }) => theme.fontSizes.h5};
            }
        }

        .monthlyPaymentSummary {
            .monthlyPaymentItem {
                .price {
                    font-weight: normal;
                }
            }
        }

        .personalizeButton {
            font-size: ${({ theme }) => theme.fontSizes.h5};
            text-transform: unset;
            background: ${({ theme }) => theme.colors.white};
            color: ${({ theme }) => theme.colors.black1};
            border-color: ${({ theme }) => theme.colors.black1};
            height: ${rem(48)};
            padding: ${rem(15)} ${rem(24)};
            font-weight: ${({ theme }) => theme.fontWeights.textRegular};

            &:hover,
            &:focus-visible {
                color: ${({ theme }) => theme.colors.primary};
                background: ${({ theme }) => theme.colors.grey4};
                border-color: ${({ theme }) => theme.colors.primary};
            }
        }

        .infoIcon {
            svg {
                g {
                    circle,
                    line {
                        stroke: ${({ theme }) => theme.colors.black};
                    }
                }
            }
        }
    }

    .personalizeButton {
        border-radius: 24px;
        &:hover,
        &:focus-visible {
            color: ${({ theme }) => theme.colors.white};
            background: ${({ theme }) => theme.colors.black};
            border-color: ${({ theme }) => theme.colors.black};
        }
    }

    .legalText {
        p {
            color: ${({ theme }) => theme.colors.grey29};
            font-size: ${({ theme }) => theme.fontSizes.h6};
            line-height: ${rem(18)};
            font-weight: ${({ theme }) => theme.fontWeights.textRegular};
        }
    }
`;
